import React, { useEffect, useState } from 'react';
import Select, { components,  } from 'react-select';
import { TbGridDots } from 'react-icons/tb';
import { HiChevronDown } from 'react-icons/hi'
import { compactMultiSelectComponents } from './compactMultiSelect';
import { getClientsOptionApi, getClientsOptionApiFilter } from 'src/context/actions/835_management/ImportFile';
import { reactLocalStorage } from 'reactjs-localstorage';
import { useSelector } from 'react-redux';
import { useDispatch } from 'react-redux';
import { setUserData } from 'src/reducer/userData/userSlice';

const Clientdropdown = ({search ,setSearch, compact = false}) => {
    const [IsCorresCategory, setIsCorresCategory] = useState(false);
    const [clientlist, setClientList] = useState([]);
    const user_type = reactLocalStorage.get('user_type');
    const {  client } = useSelector((state) => state.user);
    const dispatchUser = useDispatch();
    


    const DropdownIndicator = ({ state, ...props }) => {
        return (
            <components.DropdownIndicator {...props}>

                {search && search?.client_name?.length > 1 ? (
                    <TbGridDots style={{ fontSize: "1.5em" }} />
                ) : (
                    <HiChevronDown style={{ fontSize: "1.5em" }} />
                )}
            </components.DropdownIndicator>
        );
    };
   
    useEffect(() => {
       
        getClientsOptionApiFilter()(response => {
                let apiResponse = response?.data?.data?.results
                setClientList(apiResponse)
                if ((user_type === "client" || user_type === "facility" ) && apiResponse?.length ===1 ) { 
                    setSearch({ ...search, client_name: [apiResponse?.[0]?.value ]})
                    dispatchUser(setUserData({ client: apiResponse,isClientFreeze:true }));
                }
            });

    }, []);

    return (
        <>

<div style={{marginRight:".5rem"}} >
            <Select
                isMulti
                tabSelectsValue={false} 
                closeMenuOnSelect={false}
                components={{ DropdownIndicator: (props) => <DropdownIndicator {...props} state="corres_category" />, ...(compact ? compactMultiSelectComponents : {}) }}
                hideSelectedOptions={!compact}
                options={clientlist}
                isDisabled={  ['client','facility'].includes(user_type) && client?.length > 0 ? true : false} // USERTYPE 3 IS CLIENT

                value={clientlist?.filter((item) => search?.client_name?.includes(item?.value))}
                aria-placeholder="Correspondence Category"
                placeholder="Client Name"
                classNamePrefix='Status'
                isClearable
                onChange={(e) => { 
                    if(e.length>0){
                        setSearch({ ...search, client_name: e?.map(i => i.value) }) 
                    }else {
                        setSearch({ ...search,facility_name: [] , client_name: [] ,   })     
                    }
                    }
                }
                onFocus={() => setIsCorresCategory(true)}
                onBlur={() => setIsCorresCategory(false)}
                styles={{
                    container: (styles, state) => ({
                        ...styles,
                        borderRadius: "9px",
                        width:"230px"
                    }),
                    placeholder: styles => ({
                        ...styles,
                        fontSize: '0.9em',
                        fontWeight: 400,
                        paddingBottom: '0px'
                    }),
                    control: (styles, state) => ({
                        ...styles,
                        backgroundColor: "transparent",
                        borderLeft: 'none',
                        borderRight: 'none',
                        borderTop: 'none',
                        borderBottomColor: 'black',
                        boxShadow: "none",
                        borderRadius: "0px",
                    }),
                    indicatorSeparator: styles => ({
                        ...styles, width: "0px",
                        minHeight: "20px"
                    }),
                    valueContainer: (styles, state) => ({
                        ...styles,
                        maxHeight: IsCorresCategory ? "auto" : "30px",
                    }),
                    menu: (styles) => ({
                        ...styles,
                        zIndex: 9999,
                    }),
                }}
            />
</div>
        </>
    );
}
export default React.memo(Clientdropdown);